import { render, staticRenderFns } from "./SmsVerifier.vue?vue&type=template&id=0b9a28f8&scoped=true&"
import script from "./SmsVerifier.vue?vue&type=script&lang=js&"
export * from "./SmsVerifier.vue?vue&type=script&lang=js&"
import style0 from "./SmsVerifier.vue?vue&type=style&index=0&id=0b9a28f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a28f8",
  null
  
)

export default component.exports